/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { styles } from './definition-list.styles';

export type Definition = {
    term: ReactNode;
    description: ReactNode;
};

export type DefinitionListProps = {
    /**
     * A list of definition terms and descriptions
     */
    definitions: Definition[];

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
};

const StyledDefinitionList = styled('dl').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const DefinitionList: FunctionComponent<DefinitionListProps> = ({
    definitions,
    ...otherProps
}: DefinitionListProps) => {
    return (
        <StyledDefinitionList definitions={definitions} {...otherProps}>
            {definitions.map((definition, index) => (
                <React.Fragment key={index}>
                    <dt>{definition.term}</dt>
                    <dd>{definition.description}</dd>
                </React.Fragment>
            ))}
        </StyledDefinitionList>
    );
};
